<template>
  <div class="swiper-dots">
    <div
      v-for="page of pages"
      :key="page"
      class="swiper-dots__dot"
      :class="getDotClasses(page)"
      @click="$emit('navigate-to', page)"
    ></div>
  </div>
</template>

<script>
import { range } from 'ramda';

export default {
  name: 'SwiperPaginationDots',
  props: {
    currentPageIndex: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pages() {
      return range(0, this.totalPages);
    }
  },
  methods: {
    getDotClasses(page) {
      return {
        'swiper-dots__dot--active': this.currentPageIndex === page,
        'swiper-dots__dot--dark': this.dark
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-dots {
  --dots-color: var(--u-color-grey-900);
  display: flex;
  justify-content: center;
  align-items: center;

  &__dot {
    width: 8px;
    height: 8px;
    border: 1px solid var(--dots-color);
    border-radius: 50%;
    cursor: pointer;

    &--active {
      background-color: var(--dots-color);
    }

    &--dark {
      --dots-color: white;
    }
  }

  &__dot:not(:last-child) {
    margin-inline-end: 8px;
  }
}
</style>
